import React, { createContext, FC, useEffect, useMemo, useState } from "react";
import { Menu } from "../component/SideBar/menu";
import { hospitalConigurationType, PrivilegesContextType } from "../types/ContextsType/Privileges.Type";
import { IContext } from "../types/ContextsType/APIContext.type";
import { GetPrivileges } from "src/utils";


const defaultvalues: PrivilegesContextType = ({
    privileges: null,
    authorizedPages: [],
    setAuthorizedPages: () => { },
    setPatheName: () => { },
    setHospitalConfiguration: () => { },
    hospitalCofigurations: [],
});

export const privilegesContext = createContext<PrivilegesContextType>(defaultvalues);

const PrivilegesContainerProvider: FC<IContext> = ({ children }) => {

    const [authorizedPages, setAuthorizedPages] = useState<any[]>([])
    const [patheName, setPatheName] = useState<string>('')
    const [hospitalCofigurations, setHospitalConfiguration] = useState<hospitalConigurationType[]>([])

    const privileges = useMemo(() => {
        const directLink = window.location.hash.slice(1).split("?")[0];

        let Id = Menu?.find(screen => [patheName, directLink].includes(screen.path))?.id
        let ControllerId = Id ? Number(Menu?.find(screen => [patheName, directLink].includes(screen.path))?.id) : null;
        if (!ControllerId) {
            //@ts-ignore
            Menu?.forEach(screens => screens["children"]?.forEach(ele => {
                ControllerId = [patheName, directLink].includes(ele.path) ? ele.id : Number(ControllerId)
            }))
        }
        let AuthedActions = GetPrivileges(authorizedPages, ControllerId)

        return AuthedActions

    }, [authorizedPages, window.location, patheName])

    useEffect(() => {
        const permissions = sessionStorage.getItem("hospitalCofigurations");
        if (permissions) {
            const parsed = JSON.parse(permissions);
            setHospitalConfiguration(parsed);
        }
    }, [])

    return <privilegesContext.Provider value={

        {
            privileges,
            authorizedPages,
            setAuthorizedPages,
            setPatheName,
            setHospitalConfiguration,
            hospitalCofigurations
        }
    }>{children}</privilegesContext.Provider>;
};

export default PrivilegesContainerProvider;